
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scholarships",
      function () {
        return require("private-next-pages/scholarships/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scholarships"])
      });
    }
  